import Icon from "components/Icon"

export default function IconCard({ blok }) {
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="bg-blueWeave bg-[length:250%] bg-[50%_50%] bg-no-repeat h-[190px] lg:w-[400px] flex items-center justify-center">
        <Icon icon={blok.icon} />
      </div>
      <div className="p-7 bg-white h-[190px] flex flex-col justify-center text-primary w-full">
        <h3>{blok.heading}</h3>
        <p>{blok.content}</p>
      </div>
    </div>
  )
}
